import { render, staticRenderFns } from "./Architecturepodo.vue?vue&type=template&id=68cfd47b&scoped=true&"
import script from "./Architecturepodo.vue?vue&type=script&lang=js&"
export * from "./Architecturepodo.vue?vue&type=script&lang=js&"
import style0 from "./Architecturepodo.vue?vue&type=style&index=0&id=68cfd47b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cfd47b",
  null
  
)

/* custom blocks */
import block0 from "./Architecturepodo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports